import React from 'react';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import PasswordResetForm from './Forms/PasswordResetForm';

export type Props = { location: { query: { state?: string } } };
export const DefaultPasswordReset = ({ location: { query } }: Props) => (
  <LoginBase type="default" header={<Header />}>
    <PasswordResetForm state={query.state} />
  </LoginBase>
);
